export default function Error() {
  return (
    <>
      <section className="error-section">
        <div className="row">
          <div className="col-12 d-flex justify-content-center align-items-center div-content">
            <iframe
              src="https://giphy.com/embed/VwoJkTfZAUBSU"
              width={"350"}
              height={"480"}
            ></iframe>
            <div className="over-lab"></div>
          </div>
        </div>
      </section>
    </>
  );
}
